import React, { useEffect, useState } from "react";
import { CgAdd, CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { BiPlus } from "react-icons/bi";

const defaultMuqeem = [
  {
    id: 1,
    particular: "NEW IQAMA ISSUANCE",
    deduction: "250",
    equivalent_sar: "50",
    paid_by: "SECOND PARTY",
  },
  {
    id: 2,
    particular: "PER RENEWAL IQAMA REQUEST (3/6/9/12 Months)",
    deduction: "375",
    equivalent_sar: "75",
    paid_by: "SECOND PARTY",
  },
  {
    id: 3,
    particular: "EXIT RENTRY SINGLE",
    deduction: "250",
    equivalent_sar: "50",
    paid_by:
      "If Annual Vacation - By SECOND PARTY If Emergency/personal - By Employee",
  },
  {
    id: 4,
    particular: "EXIT RENTRY MULTIPLE",
    deduction: "375",
    equivalent_sar: "75",
    paid_by:
      "If Annual Vacation - By SECOND PARTY. If Emergency/personal - By Employee",
  },
  {
    id: 5,
    particular: "EXIT RENTRY CANCEL",
    deduction: "175",
    equivalent_sar: "35",
    paid_by:
      "If Annual Vacation - By SECOND PARTY. If Emergency/personal - By Employee",
  },
  {
    id: 6,
    particular: "FINAL EXIT",
    deduction: "250",
    equivalent_sar: "50",
    paid_by: "SECOND PARTY",
  },
  {
    id: 7,
    particular: "FINAL EXIT CANCEL",
    deduction: "175",
    equivalent_sar: "35",
    paid_by: "SECOND PARTY",
  },
  {
    id: 8,
    particular: "NAKAL KAFALA",
    deduction: "250",
    equivalent_sar: "50",
    paid_by: "SECOND PARTY",
  },
  {
    id: 9,
    particular: "PROFESSION CHANGE",
    deduction: "225",
    equivalent_sar: "45",
    paid_by: "SECOND PARTY",
  },
  {
    id: 10,
    particular: "INFORMATION UPDATE",
    deduction: "300",
    equivalent_sar: "60",
    paid_by: "SECOND PARTY",
  },
  {
    id: 11,
    particular: "MAKKAH PERMIT",
    deduction: "250",
    equivalent_sar: "50",
    paid_by: "SECOND PARTY",
  },
  {
    id: 12,
    particular: "IQAMA CARD PRINT",
    deduction: "75",
    equivalent_sar: "15",
    paid_by: "SECOND PARTY",
  },
  {
    id: 13,
    particular: "IQAMA CARD PRINT- BULK",
    deduction: "150",
    equivalent_sar: "30",
    paid_by: "SECOND PARTY",
  },
  {
    id: 14,
    particular: "EXTENSION VISIT VISA",
    deduction: "250",
    equivalent_sar: "50",
    paid_by: "SECOND PARTY",
  },
  {
    id: 15,
    particular: "MUQEEM COPY",
    deduction: "125",
    equivalent_sar: "25",
    paid_by: "SECOND PARTY",
  },
  {
    id: 16,
    particular: "EXTENTION EXIT-REENTRY",
    deduction: "450",
    equivalent_sar: "90",
    paid_by: "SECOND PARTY",
  },
  {
    id: 17,
    particular: "FINAL EXIT ON BORDER NUMBER",
    deduction: "300",
    equivalent_sar: "60",
    paid_by: "SECOND PARTY",
  },
];

const MuqeemTable = ({ SET_MUQEEM_POINTS }) => {
  const muqueem_titles = [
    "SL. No",
    "PARTICULARS",
    "MUQEEM POINTS DEDUCTION",
    "EQUIVALENT SAR FOR MUQEEM POINTS",
    "TO BE PAID BY",
    "ACTION",
  ];
  const handleSubmit = () => {};

  const [muqueemList, setMuqueemList] = useState(defaultMuqeem);
  const addNewRow = () => {
    setMuqueemList([
      ...muqueemList,
      {
        id: Math.random(),
        particular: "",
        deduction: "",
        equivalent_sar: "",
        paid_by: "",
      },
    ]);
  };

  const deleteRow = (index) => {
    if (muqueemList.length <= 1) return false;
    const updatedRows = [...muqueemList];
    updatedRows.splice(index, 1);
    setMuqueemList(updatedRows);
  };

  const updateRow = (property, updatedValue, rowIndex) => {
    const updatedList = [...muqueemList];
    updatedList[rowIndex][property] = updatedValue;
    setMuqueemList(updatedList);
  };

  useEffect(() => {
    SET_MUQEEM_POINTS(muqueemList);
  }, [muqueemList]);

  return (
    <>
      <div className="pt-2">
        <div className="font-semibold text-xl mt-10 mb-2">
          MUQEEM POINTS DEDUCTION SUMMARY
        </div>
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block uppercase">{`Slide / scroll to right >`}</p>
        <div
          className={`grid justify-items-center grid-cols-table-5 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {muqueem_titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {muqueemList?.map((list, index) => (
            <React.Fragment key={list?.id}>
              <p>{index + 1}</p>
              <textarea
                className="rounded-sm bg-slate-100 textarea-sm"
                type="text"
                defaultValue={list.particular}
                onChange={(e) =>
                  updateRow("particular", e.target.value?.toUpperCase(), index)
                }
                placeholder="ENTER PARTICULAR"
                required
              />
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="number"
                defaultValue={list.deduction}
                onChange={(e) => updateRow("deduction", e.target.value, index)}
                pattern="[0-9]*"
                placeholder="MUQEEM POINTS DEDUCTION"
                required
              />
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="number"
                defaultValue={list.equivalent_sar}
                onChange={(e) =>
                  updateRow("equivalent_sar", e.target.value, index)
                }
                pattern="[0-9]*"
                required
                placeholder="ENTER EQUIVALENT SAR FOR MUQEEM POINTS"
              />
              <textarea
                className="textarea-sm rounded-sm bg-slate-100"
                type="text"
                defaultValue={list.paid_by}
                onChange={(e) =>
                  updateRow("paid_by", e.target.value?.toUpperCase(), index)
                }
                placeholder="ENTER TO BE PAID"
                required
              />
              <div className="flex gap-3 w-20 justify-start">
                <button
                  type="button"
                  className={`p-1 px-2 rounded-md ring-1 ring-red bg-red text-white disabled:bg-rose-400 disabled:cursor-not-allowed `}
                  onClick={() => deleteRow(index)}
                  disabled={muqueemList?.length <= 1}
                  title={`${
                    muqueemList?.length <= 1 && "At least one row required"
                  }`}
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
                {index === muqueemList?.length - 1 && (
                  <button
                    className={`p-1 px-2 rounded-md ring-1 ring-slate-600 `}
                    type="button"
                    onClick={addNewRow}
                  >
                    <BiPlus size={"1.4rem"} />
                  </button>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-6 `}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default MuqeemTable;
